var map = {
	"./audio-placeholder": 630,
	"./audio-placeholder.png": 630,
	"./avatar-missing": 524,
	"./avatar-missing.png": 524,
	"./avatar-missing.svg": 880,
	"./halloween/clouds": 631,
	"./halloween/clouds.png": 631,
	"./halloween/halloween-emblem": 650,
	"./halloween/halloween-emblem.svg": 650,
	"./halloween/spider": 651,
	"./halloween/spider.svg": 651,
	"./halloween/spiderweb": 652,
	"./halloween/spiderweb.svg": 652,
	"./halloween/starfield": 653,
	"./halloween/starfield.png": 653,
	"./halloween/twinkle": 654,
	"./halloween/twinkle.svg": 654,
	"./header-missing": 540,
	"./header-missing.png": 540,
	"./reticle": 655,
	"./reticle.png": 655,
	"./soapbox-logo": 541,
	"./soapbox-logo-white": 542,
	"./soapbox-logo-white.svg": 542,
	"./soapbox-logo.svg": 541,
	"./sprite-post-functions": 674,
	"./sprite-post-functions.png": 674,
	"./video-placeholder": 675,
	"./video-placeholder.png": 675,
	"./void": 676,
	"./void.png": 676,
	"./web-push/web-push-icon_expand": 677,
	"./web-push/web-push-icon_expand.png": 677,
	"./web-push/web-push-icon_favourite": 678,
	"./web-push/web-push-icon_favourite.png": 678,
	"./web-push/web-push-icon_reblog": 679,
	"./web-push/web-push-icon_reblog.png": 679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 879;